@if (ownerHasUsers) {
	<div class="row">
		<div class="col-1">
			@if (permsService?.perms?.administrative) {
				<button
					class="btn"
					(click)="modalProps = { name: 'add-meeting-request' }"
					titleLang="add_meeting_request"
					icon="plus"
				></button>
			}
		</div>
		<div class="col-8">
			<app-gen-button-group
				[actualObj]="this"
				fieldName="status"
				optionsListName="mr_status_opts"
				(changeEvent)="filterRows()"
			/>
		</div>
	</div>
	<app-table-wrap fieldsStr="updated_at,name,status,show_motions,actions">
		@for (row of displayRows; track row) {
			<tr>
				<td>{{ row.updated_at | dateFormat }}</td>
				<td>{{ row.name }}</td>
				<td>{{ row.status | langVal }}</td>
				<td>
					@if (row.motions?.length) {
						<button
							class="btn btn-primary"
							(click)="row.showMotions = !row.showMotions"
						>
							{{ "show_motions" | langVal }}
						</button>
					}
					@if (row.showMotions) {
						<app-table-wrap fieldsStr="updated_at,status,user">
							@for (motion of row.motions; track motion) {
								<tr>
									<td>{{ motion.updated_at | dateFormat }}</td>
									<td>{{ motion.status | langVal }}</td>
									<td>{{ motion.user }}</td>
								</tr>
							}
						</app-table-wrap>
					}
				</td>
				<td>
					@if (row.status != "directed" && row.status != "accepted") {
						<app-btn-ext
							text="select_partner"
							(clickEv)="choosePartner(row)"
							[isSpin]="row.sendingToPartner"
						/>
					}
				</td>
			</tr>
		}
	</app-table-wrap>
} @else {
	<div class="row">
		<div class="col-12">
			<app-gen-button-group
				[actualObj]="this"
				fieldName="status"
				optionsListName="mr_status_opts"
				(changeEvent)="filterRows()"
			/>
		</div>
	</div>

	<app-table-wrap
		fieldsStr="updated_at,user,name,email,phone,status,remarks,actions"
	>
		@for (row of displayRows; track row) {
			<tr>
				<td>{{ row.updated_at | dateFormat }}</td>
				<td>{{ row.mr?.user || "" }}</td>
				<td>{{ row.mr?.name || "" }}</td>
				<td>{{ row.mr?.email || "" }}</td>
				<td>{{ row.mr?.phone || "" }}</td>
				<td>{{ row.status | langVal }}</td>
				<td>{{ row.mr?.remarks || "" }}</td>
				<td>
					@if (row.status != "checking") {
						<app-btn-ext
							text="checking"
							(clickEv)="sendResponse(row, true)"
							[isSpin]="row.isCheckingSend"
						/>
					}
					@if (row.status == "directed" || row.status == "checking") {
						<app-btn-ext
							text="accept_patient"
							(clickEv)="acceptPatient(row)"
							[isSpin]="row.isAcceptSending"
						/>
						<app-btn-ext
							text="reject"
							(clickEv)="sendResponse(row, false)"
							[isSpin]="row.isRejectingSend"
						/>
					}
				</td>
			</tr>
		}
	</app-table-wrap>
}

@switch (modalProps?.name) {
	@case ("add-meeting-request") {
		<app-modal-wrap
			(onClose)="modalProps = null; loadData()"
			modalWrapperClass="modal-narrow-width"
			title="add_meeting_request"
		>
			<app-add-meeting-request (onClose)="modalProps = null; loadData()" />
		</app-modal-wrap>
	}
	@case ("choose-partner") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="select_partner"
		>
			<app-choose-partner
				(onClose)="
					handleChoosePartnerClose(modalProps.row, $event); modalProps = null
				"
			/>
		</app-modal-wrap>
	}
	@case ("insert-patient-form") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="insert_patient_form"
			modalWrapperClass="modal-800"
		>
			<app-insert-patient-form
				(onClose)="handleInsertPatientClose($event); modalProps = null"
				[meeting_request]="modalProps.row.mr"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-accept-patient") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="accept_patient"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="handleConfirmAccept($event)"
				[freeText]="'accept_patient_terms' | langVal"
			/>
		</app-modal-wrap>
	}
}
